import { render } from "./Productos.vue?vue&type=template&id=42c60ef8&scoped=true"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"

import "./Productos.vue?vue&type=style&index=0&id=42c60ef8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c60ef8"]])

export default __exports__